import React, { FC, useCallback } from 'react';
import { connect } from 'react-redux';

import { ReduxState, ThunkDispatchType } from 'app/redux/types';

import { ToggleSize } from 'app/design-system/components/Toggle';
import { useTranslation } from 'app/lang';

import { SwitchToAllowRefreshWarning, switchToAllowRefreshWarning } from '../../../Layout/Sidebar/actions';
import { selectToAllowRefreshWarning } from '../../../Layout/Sidebar/selectors';
import InitialToggle from './Initial';

import dictionary from './Toggle.dictionary.json';

// ---

type StoreProps = {
  allowRefreshWarning: boolean;
};

type DispatchProp = {
  dispatch: ThunkDispatchType<SwitchToAllowRefreshWarning>;
};

type RefreshWarningToggleProps = {
  size?: ToggleSize;
  className?: string;
};

const RefreshWarningToggle: FC<RefreshWarningToggleProps & StoreProps & DispatchProp> = ({
  allowRefreshWarning,
  dispatch,
  size,
  className,
}) => {
  const { t } = useTranslation();
  const switchToAllowRefreshWarningHandler = useCallback(() => {
    dispatch(switchToAllowRefreshWarning(!allowRefreshWarning));
  }, [allowRefreshWarning]);

  return (
    <InitialToggle active={allowRefreshWarning}
                   title={t(dictionary.refreshWarningTitle)}
                   data-test="refreshWarning-toggle"
                   dataGaEvent="cart-set-warningToggle"
                   size={size}
                   className={className}
                   onChange={switchToAllowRefreshWarningHandler} />
  );
};

const mapStateToProps = (state: ReduxState): StoreProps => ({
  allowRefreshWarning: selectToAllowRefreshWarning(state),
});

export default connect(mapStateToProps)(RefreshWarningToggle);
